import * as React from "react";
import { memo, SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => {
  const { width = 12, height = 12 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${height} ${width}`}
      fill="none"
      {...props}
    >
      <path
        fill="#0E0E0E"
        d="M6 12c-1.533 0-2.87-.508-4.008-1.525C.852 9.458.2 8.189.033 6.667H1.4c.156 1.155.67 2.11 1.541 2.866.873.756 1.892 1.134 3.059 1.134 1.3 0 2.403-.453 3.308-1.359.906-.905 1.359-2.008 1.359-3.308 0-1.3-.453-2.403-1.359-3.309C8.403 1.786 7.3 1.333 6 1.333a4.5 4.5 0 0 0-2.15.534 4.954 4.954 0 0 0-1.683 1.466H4v1.334H0v-4h1.333v1.566A5.82 5.82 0 0 1 3.41.583 5.952 5.952 0 0 1 6 0a5.81 5.81 0 0 1 2.342.475c.728.317 1.36.744 1.9 1.283.539.54.966 1.172 1.283 1.9A5.81 5.81 0 0 1 12 6c0 .833-.158 1.614-.475 2.341a6.1 6.1 0 0 1-1.283 1.9c-.54.54-1.172.967-1.9 1.284A5.81 5.81 0 0 1 6 12Zm1.867-3.2L5.333 6.267v-3.6h1.334v3.066L8.8 7.867l-.933.933Z"
      />
    </svg>
  );
};
const Memo = memo(SvgComponent);
export { Memo as LastUpdate };
